import { HintIcon, LinkText, Space, Text } from '@/components';
import { FALLBACK_TEXT } from '@/utils';
import {
  type FC,
  type ReactElement,
  type ReactNode,
  isValidElement,
} from 'react';

type Props = (
  | { variant: 'link'; href: string } // Allow href only when 'variant' is 'link'.
  | { variant?: 'text'; fallbackText?: string }
) & {
  title: string;
  titlePrefix?: ReactNode;
  hint?: string;
  supplementary?: ReactNode;
  text: string | number | null | ReactElement | undefined;
  direction?: 'vertical' | 'horizontal';
  nowrapTitle?: boolean;
};

export const TitledText: FC<Props> = (props) => {
  const {
    title,
    titlePrefix,
    hint,
    supplementary,
    text,
    variant = 'text',
    direction = 'vertical',
    nowrapTitle,
  } = props;

  const href = 'href' in props && props.href;
  const fallbackText =
    ('fallbackText' in props && props.fallbackText) ?? FALLBACK_TEXT;
  const stringText = text?.toString() ?? '';

  return (
    <Space size="small" direction={direction}>
      <Space data-dd-privacy="allow">
        {titlePrefix}
        <Text
          variant="body"
          text={title}
          color="secondary"
          style={nowrapTitle ? { whiteSpace: 'nowrap' } : undefined}
        />
        {hint && <HintIcon hint={hint} />}
        {supplementary}
      </Space>

      {isValidElement(text) ? (
        text
      ) : variant === 'link' && stringText && href ? (
        <LinkText text={stringText} href={href} />
      ) : (
        <Text
          weight="regular"
          variant="body"
          text={text?.toString()}
          fallbackText={fallbackText || undefined}
        />
      )}
    </Space>
  );
};
